import React from "react"
import Icon from "./Icon"
import cassiaBlueWildflowerTour from "../../../../../assets/images/channel_pages/cassia-blue-wildflower-tour.png"

// Email composer preview for "Cassia Blue: The Wildflower Tour" — Email channel hero.
// The synced event block (dashed border, accent badge tab, 2-col event meta grid)
// is the centerpiece of this visual.

const EmailComposerPreview = () => (
  <div style={{ position: "relative", width: "100%", maxWidth: 470, margin: "0 auto" }}>
    {/* Synced chip (top-left) */}
    <div style={{
      position: "absolute", top: -18, left: -30, zIndex: 4,
      padding: "8px 12px 8px 10px",
      background: "rgba(50,20,8,.78)",
      backdropFilter: "blur(14px)", WebkitBackdropFilter: "blur(14px)",
      border: "1px solid rgba(255,255,255,.14)",
      borderRadius: 10, color: "#fff",
      display: "flex", alignItems: "center", gap: 8,
      fontSize: 12, fontWeight: 600, whiteSpace: "nowrap",
      boxShadow: "0 10px 28px rgba(0,0,0,.28)",
      animation: "vsFloat 6s ease-in-out infinite",
    }}>
      <span style={{
        width: 18, height: 18, borderRadius: 5,
        background: "linear-gradient(135deg,#FF7322,#FFB86B)",
        display: "flex", alignItems: "center", justifyContent: "center", color: "#fff",
      }}>
        <Icon name="check" size={11} stroke={3}/>
      </span>
      <span>Event details synced · auto-updates</span>
    </div>

    <div style={{
      position: "relative", zIndex: 2,
      background: "#fff", borderRadius: 14,
      boxShadow: "0 30px 80px rgba(50,20,8,.40), 0 10px 24px rgba(50,20,8,.22)",
      overflow: "hidden",
      transform: "perspective(1400px) rotateY(-6deg) rotateX(2deg)",
      transformOrigin: "center",
    }}>
      <div style={{
        display: "flex", alignItems: "center", gap: 7,
        padding: "10px 12px",
        background: "#F8FAFC",
        borderBottom: "1px solid rgba(15,23,42,.06)",
      }}>
        <div style={{ width: 10, height: 10, borderRadius: "50%", background: "#FF6057" }}/>
        <div style={{ width: 10, height: 10, borderRadius: "50%", background: "#FFBD2E" }}/>
        <div style={{ width: 10, height: 10, borderRadius: "50%", background: "#27C93F" }}/>
        <div style={{ marginLeft: 8, fontSize: 10.5, color: "#64748B", fontWeight: 600 }}>Campaign preview</div>
      </div>

      <div style={{ padding: "14px 18px 10px", borderBottom: "1px solid #F1F5F9" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
          <div style={{
            width: 28, height: 28, borderRadius: 8,
            background: "var(--mpp-gradient)",
            color: "#fff", fontSize: 11, fontWeight: 800,
            display: "flex", alignItems: "center", justifyContent: "center",
          }}>MT</div>
          <div style={{ lineHeight: 1.2 }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: "#0F172A" }}>Monarch Theatre</div>
            <div style={{ fontSize: 10.5, color: "#64748B" }}>tickets@monarchtheatre.la · to you</div>
          </div>
          <div style={{ marginLeft: "auto", fontSize: 10.5, color: "#64748B" }}>Apr 28</div>
        </div>
        <div style={{ fontSize: 15, fontWeight: 700, color: "#0F172A", lineHeight: 1.3 }}>
          Cassia Blue brings The Wildflower Tour to LA, presale opens tonight
        </div>
      </div>

      <div style={{
        position: "relative",
        aspectRatio: "2 / 1",
        backgroundImage: `url(${cassiaBlueWildflowerTour})`,
        backgroundSize: "cover",
        backgroundPosition: "center 22%",
        overflow: "hidden",
        padding: 18,
        display: "flex", flexDirection: "column", justifyContent: "flex-end",
      }}>
        <div style={{
          position: "absolute", inset: 0,
          background: "linear-gradient(180deg, rgba(20,8,2,.05) 0%, rgba(20,8,2,.15) 50%, rgba(20,8,2,.78) 100%)",
        }}/>
        <div style={{ position: "relative", zIndex: 2, color: "#fff" }}>
          <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: ".14em", textTransform: "uppercase", opacity: .9, marginBottom: 6 }}>
            Monarch Theatre presents
          </div>
          <div style={{ fontFamily: "Manrope, system-ui, sans-serif", fontSize: 26, lineHeight: 1.0, fontWeight: 800, letterSpacing: "-.03em", textShadow: "0 2px 18px rgba(0,0,0,.5)" }}>
            Cassia Blue<br/>
            <span style={{ fontSize: 16, fontWeight: 600, opacity: .92, letterSpacing: "-.01em" }}>The Wildflower Tour</span>
          </div>
        </div>
      </div>

      <div style={{
        margin: "14px 18px",
        padding: 14,
        background: "#FFF7F0",
        border: "1px dashed var(--mpp-accent-line)",
        borderRadius: 10,
        position: "relative",
      }}>
        <div style={{
          position: "absolute", top: -9, left: 12,
          display: "inline-flex", alignItems: "center", gap: 5,
          padding: "3px 8px", borderRadius: 999,
          background: "var(--mpp-gradient)", color: "#fff",
          fontSize: 9.5, fontWeight: 800, letterSpacing: ".1em", textTransform: "uppercase",
          boxShadow: "var(--mpp-cta-shadow)",
        }}>
          <Icon name="zap" size={9} stroke={3}/> Synced event block
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginTop: 4 }}>
          {[
            { k: "Event", v: "Cassia Blue: The Wildflower Tour" },
            { k: "Date", v: "Sat · May 9" },
            { k: "Venue", v: "Monarch Theatre · Los Angeles" },
            { k: "Doors", v: "8:00 PM · All Ages" },
          ].map((row, i) => (
            <div key={i}>
              <div style={{ fontSize: 9.5, fontWeight: 700, color: "var(--mpp-accent)", letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 2 }}>{row.k}</div>
              <div style={{ fontSize: 12, fontWeight: 600, color: "#0F172A" }}>{row.v}</div>
            </div>
          ))}
        </div>

        <div style={{
          marginTop: 12,
          display: "inline-flex", alignItems: "center", gap: 6,
          padding: "9px 14px", borderRadius: 8,
          background: "var(--mpp-gradient)", color: "#fff",
          fontSize: 12, fontWeight: 700,
          boxShadow: "var(--mpp-cta-shadow)",
        }}>
          <Icon name="ticket" size={12} stroke={2.4}/> Get Tickets → monarchtheatre.la
        </div>
      </div>

      <div style={{ padding: "4px 18px 18px", fontSize: 12.5, lineHeight: 1.55, color: "#475569" }}>
        <p style={{ margin: "0 0 8px" }}>Los Angeles, Cassia Blue brings The Wildflower Tour to the Monarch this May, and we're opening presale to our list a full day before the public…</p>
        <div style={{ display: "flex", gap: 4 }}>
          {[80, 60, 70, 45].map((w, i) => (
            <div key={i} style={{ flex: w, height: 6, borderRadius: 3, background: "#F1F5F9" }}/>
          ))}
        </div>
      </div>
    </div>

    {/* Open rate chip (top-right) */}
    <div style={{
      position: "absolute", top: 104, right: -26, zIndex: 4,
      padding: "10px 12px",
      background: "rgba(50,20,8,.80)",
      backdropFilter: "blur(14px)", WebkitBackdropFilter: "blur(14px)",
      border: "1px solid rgba(255,255,255,.14)",
      borderRadius: 10, color: "#fff",
      whiteSpace: "nowrap",
      boxShadow: "0 10px 28px rgba(0,0,0,.28)",
      animation: "vsFloat 8s ease-in-out -1s infinite",
    }}>
      <div style={{ fontSize: 10, fontWeight: 600, opacity: .7, letterSpacing: ".08em", textTransform: "uppercase" }}>Open rate</div>
      <div style={{ fontSize: 17, fontWeight: 800, letterSpacing: "-.02em", marginTop: 2 }}>
        47% <span style={{ fontSize: 11, fontWeight: 700, color: "#FFC48A" }}>▲ 12pt</span>
      </div>
    </div>

    {/* Subscriber chip (bottom-right) */}
    <div style={{
      position: "absolute", bottom: 20, right: -46, zIndex: 4,
      padding: "10px 12px",
      background: "rgba(255,255,255,.96)",
      borderRadius: 10,
      boxShadow: "0 14px 32px rgba(50,20,8,.26)",
      display: "flex", alignItems: "center", gap: 10,
      animation: "vsFloat 7s ease-in-out -2s infinite",
    }}>
      <div style={{
        width: 30, height: 30, borderRadius: 8,
        background: "linear-gradient(135deg, var(--mpp-accent-soft), rgba(142,50,21,.12))",
        display: "flex", alignItems: "center", justifyContent: "center",
        color: "var(--mpp-accent)",
      }}>
        <Icon name="users" size={15} stroke={2.2}/>
      </div>
      <div style={{ lineHeight: 1.15 }}>
        <div style={{ fontSize: 10.5, fontWeight: 600, color: "#64748B", letterSpacing: ".06em", textTransform: "uppercase" }}>Subscribers</div>
        <div style={{ fontSize: 12.5, fontWeight: 700, color: "#0F172A" }}>12,480 · 3 segments</div>
      </div>
    </div>
  </div>
)

export default EmailComposerPreview
